<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" v-model="fieldsValues.usersFile" v-bind="fieldsDefinitions.usersFile"
        required accept="*" @error="(err) => setFieldError('usersFile', err)"/>
      <ccs-input class="ccs-6" v-model="fieldsValues.projectsFile" v-bind="fieldsDefinitions.projectsFile"
        required accept="*" @error="(err) => setFieldError('projectsFile', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Импортировать
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'ImportEvent',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        usersFile: {
          isValid: false,
          error: '',
          required: true,
          type: "file",
          label: "Файл с пользователями",
        },
        projectsFile: {
          isValid: false,
          error: '',
          required: true,
          type: "file",
          label: "Файл с проектами",
        },
      },
      fieldsValues: {
        usersFile: null,
        projectsFile: null,
      },
    };
  },
  computed: {
    ...mapState('events', ['event']),
  },
  methods: {
    ...mapActions('events', ['getEvent', 'importEvent']),
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        try {
          this.$toasted.info('Запрос на импорт отправлен. Не закрывайте вкладку.');

          await this.importEvent({
            users_file: this.fieldsValues.usersFile,
            projects_file: this.fieldsValues.projectsFile,
          });
          this.getEvent();
          this.$toasted.success('Импорт успешен');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>